import { TemplateData } from './htmlTemplates';

export const magazineStyleTemplate = {
  id: 'magazine-style',
  name: '杂志风格',
  description: '专业杂志布局，适合高端品牌和正式内容',
  category: 'professional',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 50px 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .brand-minimal {
          position: absolute;
          top: 25px;
          right: 25px;
          font-size: 14px;
          opacity: 0.4;
        }

        .title {
          font-size: 44px;
          font-weight: 900;
          color: #000000;
          line-height: 0.9;
          margin-bottom: 30px;
          letter-spacing: -2px;
          text-align: left;
          width: 100%;
        }

        .title-emphasis {
          background: ${data.theme.primaryColor};
          color: white;
          padding: 0 8px;
          margin: 0 2px;
          border-radius: 4px;
        }

        .subtitle {
          font-size: 16px;
          color: #666666;
          line-height: 1.6;
          font-weight: 400;
          text-align: left;
          max-width: 280px;
        }

        .key-phrase {
          background: ${data.theme.accentColor}30;
          color: ${data.theme.primaryColor};
          padding: 1px 6px;
          border-radius: 8px;
          font-weight: 600;
          margin: 0 1px;
        }

        .vertical-line {
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 120px;
          background: ${data.theme.primaryColor};
          border-radius: 2px;
        }

        .grid-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.02;
          background-image:
            linear-gradient(rgba(0,0,0,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,0,0,0.1) 1px, transparent 1px);
          background-size: 20px 20px;
          z-index: 0;
        }

        .content {
          position: relative;
          z-index: 1;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="grid-overlay"></div>
        <div class="brand-minimal">${data.theme.logo}</div>
        <div class="vertical-line"></div>
        <div class="content">
          <h1 class="title">
            ${data.title.split('').map((char, i) =>
              i % 3 === 0 ? `<span class="title-emphasis">${char}</span>` : char
            ).join('')}
          </h1>
          <p class="subtitle">${data.subtitle.replace(/([^\s]{2,5})/g, '<span class="key-phrase">$1</span>')}</p>
        </div>
      </div>
    </body>
    </html>
  `
};
